import {Record} from 'immutable';
import {schema} from 'normalizr';

const Participant = Record({
    id: null,
    externalId: null,
    name: null,
    mark: null,
    username: null,
});

export const ParticipantSchema = new schema.Entity('participants');

export default Participant;
